import { render, staticRenderFns } from "./Judgement.vue?vue&type=template&id=70354972"
import script from "./Judgement.vue?vue&type=script&lang=js"
export * from "./Judgement.vue?vue&type=script&lang=js"
import style0 from "./Judgement.vue?vue&type=style&index=0&id=70354972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports